module.exports = __webpack_public_path__ + "static/img/poster_1.b725469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/poster_1.jpg
// module id = Dxje
// module chunks = 0